import { BRT_STATION_ID, Line } from "../types";

export const BRT_LINE: Line = {
    line: [
        BRT_STATION_ID.SATHON,
        BRT_STATION_ID.AKHAN_SONGKHRO,
        BRT_STATION_ID.TECHNIC_KRUNGTHEP,
        BRT_STATION_ID.THANON_CHAN,
        BRT_STATION_ID.NARARAM_III,
        BRT_STATION_ID.WAT_DAN,
        BRT_STATION_ID.WAT_PARIWAT,
        BRT_STATION_ID.WAT_DOKMAI,
        BRT_STATION_ID.RAMA_IX_BRIDGE,
        BRT_STATION_ID.CHAROENRAT,
        BRT_STATION_ID.RAMA_III_BRIDGE,
        BRT_STATION_ID.RATCHAPRUEK,
    ],
};